export const isNonNullable = <T>(v: T): v is NonNullable<T> =>
  v !== null && v !== undefined

// export const isDefined = <T>(value: T | undefined): value is T =>
//   value !== undefined
